/**
 * Constants for ratings and review summary id
 * This file contains only the enum without any imports to avoid circular dependencies
 */
export enum RatingsAndReviewMetric {
    WEEKLY_RATING_VOLUME = 'childWeeklyRatingVolume',
    CHILD_POSITIVE_WEEKLY_RATING_VOLUME = 'childPositiveWeeklyRatingVolume',
    PARENT_WEEKLY_RATING_VOLUME = 'parentWeeklyRatingVolume',
    PARENT_POSITIVE_WEEKLY_RATING_VOLUME = 'parentPositiveWeeklyRatingVolume',
    PARENT_WEEKLY_RATING = 'parentWeeklyRating',
    WEEKLY_RATING = 'weeklyRating',
    PARENT_LIFETIME_RATING_VOLUME = 'parentLifetimeRatingVolume',
    PARENT_LIFETIME_RATING = 'parentLifetimeRating',
    CUMULATIVE_RATING_VOLUME = 'cumulativeRatingVolume',
    CUMULATIVE_RATING = 'cumulativeRating',
    WEEKLY_REVIEW_VOLUME = 'weeklyReviewVolume',
    WEEKLY_REVIEW_RATING = 'weeklyReviewRating',
    CUMULATIVE_REVIEW_VOLUME = 'lifetimeReviewVolume',
    CUMULATIVE_REVIEW_RATING = 'lifetimeRating',
    REVIEW_QUALITY_SCORE = 'reviewQualityScore',
    CHILD_LIFETIME_RATING_VOLUME = 'childLifetimeRatingVolume',
    CHILD_LIFETIME_RATING = 'childLifetimeRating',
    CHILD_WEEKLY_RATING = 'childWeeklyRating',
    WEIGHTED_LIFETIME_REVIEW_RATING = 'weightedLifetimeReviewRating',
    WORD_COUNT = 'wordCount',
    WEIGHTED_CHILD_WEEKLY_RATING = 'weightedChildWeeklyRating',
    WEIGHTED_CHILD_LIFETIME_RATING = 'weightedChildLifetimeRating',
    WEIGHTED_PARENT_WEEKLY_RATING = 'weightedParentWeeklyRating',
    WEIGHTED_PARENT_LIFETIME_RATING = 'weightedParentLifetimeRating',
    WEIGHTED_WEEKLY_REVIEW_RATING = 'weightedWeeklyReviewRating',
    KEYWORD_COUNT = 'keywordCount',
    KEYWORD_POPULARITY = 'keywordPopularity',
    WEEKLY_POSITIVE_SENTIMENT = 'weeklyPositiveSentiment',
    WEEKLY_NEGATIVE_SENTIMENT = 'weeklyNegativeSentiment',
    WEEKLY_NEUTRAL_SENTIMENT = 'weeklyNeutralSentiment',
    CUMULATIVE_POSITIVE_SENTIMENT = 'cumulativePositiveSentiment',
    CUMULATIVE_NEGATIVE_SENTIMENT = 'cumulativeNegativeSentiment'
}
